import Tooltip from './Tooltip.js';
import isTouchScreenDevice from '../../functions/isTouchScreenDevice';
const els = document.querySelectorAll('.js-tooltip');

for (let el of els) {
    if (!isTouchScreenDevice()) {
        new Tooltip(el);
    }
}
